import React from "react";
import { Grid, Segment, Header, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import PageData from "../SiteLayout/Pages.json";
 
const HomeCourseInfo = () => (
    <Grid columns={2} centered>
        {
            PageData.pages.map(page => 
                <Grid.Column key={page.route}>
                    <Segment placeholder inverted raised className="HomeCourseInfoCard" as={Link} to={page.route}>
                        <Header icon className="HomeCourseInfoCardHeader">
                            <Icon name={page.icon} />
                            {page.name} {page.arName}
                            <Header.Subheader className="HomeCourseInfoCardSubHeader">
                                {page.description.substring(0,100)} ...
                            </Header.Subheader>
                        </Header>
                    </Segment>
                </Grid.Column>
            )
        }
    </Grid>
)
export default HomeCourseInfo;